import { Star } from "lucide-react"

import { cn } from "@/lib/utils"

type RatingStarsProps = {
  value: number
  size?: "sm" | "md" | "lg"
  className?: string
}

export function RatingStars({
  value,
  size = "md",
  className,
}: RatingStarsProps) {
  const roundedValue = Math.round(value)

  const sizeClassMap = {
    sm: "h-3.5 w-3.5",
    md: "h-4 w-4",
    lg: "h-5 w-5",
  }

  return (
    <div
      className={cn("flex items-center gap-1", className)}
      aria-label={`Рейтинг: ${value} з 5`}
    >
      {[1, 2, 3, 4, 5].map((star) => {
        const active = star <= roundedValue

        return (
          <Star
            key={star}
            className={cn(
              sizeClassMap[size],
              active
                ? "fill-amber-400 text-amber-400"
                : "fill-transparent text-neutral-300",
            )}
          />
        )
      })}
    </div>
  )
}
